import { render } from "./neweditemployee.vue?vue&type=template&id=35cd81c8&scoped=true"
import script from "./neweditemployee.vue?vue&type=script&lang=js"
export * from "./neweditemployee.vue?vue&type=script&lang=js"

import "./neweditemployee.vue?vue&type=style&index=0&id=35cd81c8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35cd81c8"]])

export default __exports__